import TabAllergens from './TabAllergens';

export default TabAllergens;
